export default __webpack_public_path__ + "static/media/fraction~CccezzAD.13315ce6.svg";